<script setup>
import {ref, computed, watch} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import ComponentEditorBtnGroup from "@/components/ComponentEditorBtnGroup.vue"
import Button from "@/common/Button.vue"
import {useComponentsStore} from "@/stores/components"

const route = useRoute()
const router = useRouter()
const componentStore = useComponentsStore()

// --- State ---

const currentHeading = ref('')

// --- Computed ---

const component = computed(() => componentStore.items.find(o => o.tableName === route.params.component))

// --- Methods ---

const updateView = () => {
    if (route.name === 'componentSettings') {
        currentHeading.value = 'Settings'
    } else if (route.name === 'componentFields') {
        currentHeading.value = 'Fields'
    } else {
        currentHeading.value = ''
    }
}

const goToListing = () => {
    if (component.value?.tableName) {
        router.push({
            name: 'list',
            params: {component: component.value.tableName}
        })
    }
}

// --- Watchers ---

watch(
    () => route.fullPath,
    () => {
        updateView()
    },
    {immediate: true}
)
</script>

<template>
    <div class="d-flex h-100 overflow-auto flex-column">
        <header
            v-if="currentHeading"
            :key="'header-' + route.fullPath"
            class="d-flex align-items-center border-bottom"
        >
            <span class="ms-2 flex-fill d-flex align-items-center small">
                <Button class="btn-sm lh-1 me-1 p-1" @click="goToListing">
                    <small>{{ component?.title }}</small>
                </Button>

                <i class="bi-chevron-compact-right"/>

                <small class="px-2 d-inline-block">{{ currentHeading }}</small>
            </span>

            <ComponentEditorBtnGroup/>
        </header>

        <router-view
            :key="route.params.component"
            class="overflow-auto"
        />
    </div>
</template>